module.exports = __webpack_public_path__ + "img/sap.15e365fe.svg";